/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalEmrDocumentPullStart
 */
export interface ExternalEmrDocumentPullStart {
    /**
     * False when a pull was already running for this patient
     */
    is_started: boolean;
}

/**
 * Check if a given object implements the ExternalEmrDocumentPullStart interface.
 */
export function instanceOfExternalEmrDocumentPullStart(value: object): value is ExternalEmrDocumentPullStart {
    if (!('is_started' in value) || value['is_started'] === undefined) return false;
    return true;
}

export function ExternalEmrDocumentPullStartFromJSON(json: any): ExternalEmrDocumentPullStart {
    return ExternalEmrDocumentPullStartFromJSONTyped(json, false);
}

export function ExternalEmrDocumentPullStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocumentPullStart {
    if (json == null) {
        return json;
    }
    return {
        
        'is_started': json['is_started'],
    };
}

export function ExternalEmrDocumentPullStartToJSON(json: any): ExternalEmrDocumentPullStart {
    return ExternalEmrDocumentPullStartToJSONTyped(json, false);
}

export function ExternalEmrDocumentPullStartToJSONTyped(value?: ExternalEmrDocumentPullStart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_started': value['is_started'],
    };
}

